






import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'AdminEditVehicleSidebar',
  components: {

  }

})
export default class AdminEditVehicleSidebar extends Vue {

}
